module.exports = __webpack_public_path__ + "static/p-main-9987930399684b77cbd30f574d86441f.svg";